import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=363dc0f4&lang=pug&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports